import React from 'react'
import PropTypes from 'prop-types'
import ExistingCondition from './ExistingCondition'
import AdditionalInstructions from './AdditionalInstruction'
import InstructionList from './InstructionList'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TREATMENT_PLAN_WIDGET } from '../../../process/ui-definition/process-ui'

const TreatmentPlan = ({ treatmentPlan, readOnly, changeTreatmentPlan, changeInstruction, changeExistingCondition, changeDoNotMove, changeLeaveSpaceOpen, saveTreatmentPlan }) => {
    if (!currentUserHasAccess(TREATMENT_PLAN_WIDGET)) {
        return null
    }

    if (!treatmentPlan) {
        return null
    }

    return (
        <div>
            <ExistingCondition
                saveTreatmentPlan={saveTreatmentPlan}
                changeExistingCondition={changeExistingCondition}
                existingCondition={treatmentPlan.existingCondition}
                readOnly={readOnly}/>

            <InstructionList
                saveTreatmentPlan={saveTreatmentPlan}
                changeTreatmentPlan={changeTreatmentPlan}
                treatmentPlan={treatmentPlan}
                readOnly={readOnly}
                changeInstruction={changeInstruction}
            />

            <AdditionalInstructions
                saveTreatmentPlan={saveTreatmentPlan}
                changeDoNotMove={changeDoNotMove}
                changeLeaveSpaceOpen={changeLeaveSpaceOpen}
                treatmentPlan={treatmentPlan}
                changeTreatmentPlan={changeTreatmentPlan}
                readOnly={readOnly}
            />
        </div>
    )
}

TreatmentPlan.propTypes = {
    treatmentPlan: PropTypes.object,
    changeTreatmentPlan: PropTypes.func.isRequired,
    changeExistingCondition: PropTypes.func.isRequired,
    changeInstruction: PropTypes.func.isRequired,
    changeDoNotMove: PropTypes.func.isRequired,
    changeLeaveSpaceOpen: PropTypes.func.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
}

export default TreatmentPlan



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/TreatmentPlan.js